import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LayoutPresensi } from './layoutPresensi';
import LokasiPresensi from '../../componen/presensi/admin/LokasiPresensi';

export const LokasiPresensiPages = () => {
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate('/', { replace: true });
  }, [isError, navigate]);

  return (
   <LayoutPresensi>
    <LokasiPresensi />
   </LayoutPresensi>

  )
}
